<template>
  <v-card>
    <v-card-title class="headline">Information saknas!</v-card-title>

    <v-card-text>
      <p>
        Följande fel måste korrigeras innan du kan registrera.
      </p>
      <ul>
        <li v-for="(error, $i) in errors" :key="$i">{{ error }}</li>
      </ul>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="close">
        Tillbaka
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ValidationModal',

  props: {
    errors: Array
  },

  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>
